var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.01,9.464l-2.93-1.256a.628.628,0,0,0-.732.18l-1.3,1.585A9.7,9.7,0,0,1,3.416,5.339L5,4.042a.626.626,0,0,0,.18-.732L3.926.38A.632.632,0,0,0,3.207.016L.487.644A.628.628,0,0,0,0,1.256,12.136,12.136,0,0,0,12.137,13.393a.628.628,0,0,0,.612-.487l.628-2.72a.635.635,0,0,0-.366-.722Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.973ef28900eebe72819172d2056ffc0f.svg";
export { ForwardRef as ReactComponent };